import axios from "../../../axios";
import { addNotification } from "../../../Utilities/notifications";

export const inviteUsers = async (payload, org_id) => {
  try {
    let { data } = await axios.post(`${window._env.REACT_APP_EMCONSOLE_API_URL}/v1/organization/${org_id}/users/invite`, payload);
    if(data.length > 0) {
      data.forEach(obj => {
        addNotification({
          title: "Techforce.ai",
          message:obj.status === "failed" ? `Inviting ${obj.email} was ${obj.status} `:`Inviting ${obj.email} was ${obj.status} and email sent to ${obj.email}`,
          type: obj.status === "failed" ? "danger" : "success"
        });
      })
    }
    return data;
  } catch (err) {
    console.log("error while creating organization", err.message);
  }
};
